import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { AppLogo } from '../components/AppLogo.js';
import { NavLink } from '../components/NavLink.js';
import { ADMIN_NAV_ITEMS } from '../routes/config.js';

export const AdminLayout: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        width: '100%',
        backgroundColor: 'var(--color-bg-primary)',
      }}
    >
      {/* Admin Desktop Sidebar */}
      <aside
        style={{
          width: 'var(--sidebar-width)',
          backgroundColor: 'var(--color-bg-surface)',
          borderRight: '2px solid var(--color-admin-accent)',
          display: 'flex',
          flexDirection: 'column',
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            height: 'var(--header-height)',
            padding: '0 16px',
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid var(--color-border-subtle)',
          }}
        >
          <AppLogo badgeText="Admin" />
        </div>

        <div
          style={{
            padding: '8px 12px',
            margin: '8px',
            backgroundColor: 'var(--color-admin-bg)',
            borderRadius: 'var(--radius-sm)',
            border: '1px solid var(--color-admin-accent)',
            fontSize: '0.75rem',
            color: 'var(--color-admin-accent)',
            fontWeight: 600,
          }}
        >
          ⚠️ Admin Sandbox
        </div>

        <nav
          aria-label="Admin Console Navigation"
          style={{
            flex: 1,
            padding: '12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            overflowY: 'auto',
          }}
        >
          {ADMIN_NAV_ITEMS.map((item) => (
            <NavLink key={item.id} to={item.path} label={item.navLabel || item.title} />
          ))}
        </nav>

        <div style={{ padding: '16px', borderTop: '1px solid var(--color-border-subtle)' }}>
          <Link
            to="/dashboard"
            style={{
              fontSize: '0.85rem',
              color: 'var(--color-text-secondary)',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            ← Exit Admin Console
          </Link>
        </div>
      </aside>

      {/* Main Admin Content Wrapper */}
      <div
        style={{
          flex: 1,
          marginLeft: 'var(--sidebar-width)',
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        <header
          style={{
            height: 'var(--header-height)',
            padding: '0 24px',
            backgroundColor: 'var(--color-bg-surface)',
            borderBottom: '1px solid var(--color-border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--color-text-primary)' }}>
            Admin Management Console
          </h2>
          <span
            style={{
              fontSize: '0.75rem',
              padding: '3px 8px',
              borderRadius: 'var(--radius-sm)',
              backgroundColor: 'var(--color-admin-bg)',
              color: 'var(--color-admin-accent)',
              border: '1px solid var(--color-admin-accent)',
              fontWeight: 600,
            }}
          >
            Server Custom Claim Verified
          </span>
        </header>

        <main
          style={{
            flex: 1,
            padding: '24px 20px',
            maxWidth: '1200px',
            width: '100%',
            margin: '0 auto',
          }}
        >
          {/* Admin Notice */}
          <div
            style={{
              padding: '16px',
              backgroundColor: 'var(--color-admin-bg)',
              borderRadius: 'var(--radius-md)',
              border: '1px solid var(--color-admin-accent)',
              marginBottom: '24px',
              fontSize: '0.85rem',
              color: 'var(--color-text-secondary)',
            }}
          >
            <strong style={{ color: 'var(--color-admin-accent)' }}>
              Architectural Security Directive:
            </strong>
            <p style={{ marginTop: '4px' }}>
              Entry to admin routes is validated using the server-issued Firebase `admin: true`
              custom claim. Profile fields and client state cannot grant admin access.
            </p>
          </div>

          <Outlet />
        </main>
      </div>
    </div>
  );
};
